import styled from 'styled-components'

export const Pane = styled.div`
  border: 1px dashed #e8e8e8;
  margin-top: 12px;
  padding: 12px 12px;
  text-align: center;
  > img {
    display: inline;
    vertical-align: middle;
  }
  > span {
    margin-left: 8px;
    font-weight: 400;
    vertical-align: middle;
  }
  > p {
    opacity: 0.65;
    margin: 12px 0 0 0;
  }
`;